import CryptoJS from 'crypto-js'
import appConfig from '@/app.config.js'

class Crypto {

    constructor() {
        this.passphrase = appConfig.passphraseKey
    }

    enc(jsonStr) {

        var result = CryptoJS.AES.encrypt(jsonStr, this.passphrase, {
            format: this.cryptoJSAesJson()
        }).toString()

        return JSON.parse(result)
    }

    dec(jsonStr) {

        var result = CryptoJS.AES.decrypt(jsonStr, this.passphrase, {
            format: this.cryptoJSAesJson()
        }).toString(CryptoJS.enc.Utf8)

        return JSON.parse(result)
    }

    cryptoJSAesJson() {

        return {

            stringify: function (cipherParams) {
                var j = {
                    ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64)
                };
                if (cipherParams.iv) j.iv = cipherParams.iv.toString();
                if (cipherParams.salt) j.s = cipherParams.salt.toString();
                return JSON.stringify(j).replace(/\s/g, '');
            },

            parse: function (jsonStr) {
                var j = JSON.parse(jsonStr);
                var cipherParams = CryptoJS.lib.CipherParams.create({
                    ciphertext: CryptoJS.enc.Base64.parse(j.ct)
                });
                if (j.iv) cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv);
                if (j.s) cipherParams.salt = CryptoJS.enc.Hex.parse(j.s);
                return cipherParams;
            }
        }
    }
}

export default new Crypto
